// Mobile Menu Drawer Search Functionality
document.addEventListener('DOMContentLoaded', function() {
  const drawerSearch = document.querySelector('.menu-drawer__search');
  if (!drawerSearch) return;

  const searchInput = drawerSearch.querySelector('.search__input');
  const resetButton = drawerSearch.querySelector('.reset__button');
  const searchForm = drawerSearch.querySelector('form');
  
  // Handle reset button visibility
  if (searchInput && resetButton) {
    searchInput.addEventListener('input', function() {
      if (this.value.length > 0) {
        resetButton.classList.remove('hidden');
      } else {
        resetButton.classList.add('hidden');
      }
    });
    
    // Handle reset button click
    resetButton.addEventListener('click', function(e) {
      e.preventDefault();
      searchInput.value = '';
      searchInput.focus();
      this.classList.add('hidden');
      
      // Close predictive search if open
      if (window.predictiveSearch) {
        searchInput.setAttribute('aria-expanded', 'false');
        window.predictiveSearch.close();
      }
    });
  }
  
  // Prevent form submission if search is empty
  if (searchForm) {
    searchForm.addEventListener('submit', function(e) {
      const query = searchInput.value.trim();
      if (!query) {
        e.preventDefault();
        searchInput.focus();
      }
    });
  }
  
  // Focus search input when drawer opens
  const menuDrawer = document.querySelector('header-drawer');
  if (menuDrawer) {
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
          const details = menuDrawer.querySelector('details');
          if (details && details.hasAttribute('open')) {
            // Small delay to ensure drawer animation has started
            setTimeout(() => {
              searchInput.focus();
            }, 100);
          }
        }
      });
    });
    
    const config = { attributes: true, subtree: true };
    observer.observe(menuDrawer, config);
  }
  
  // Handle predictive search positioning in drawer
  if (window.predictiveSearch && drawerSearch.querySelector('predictive-search')) {
    const predictiveSearchEl = drawerSearch.querySelector('.predictive-search');
    
    // Adjust predictive search position when it opens
    searchInput.addEventListener('focus', function() {
      if (predictiveSearchEl) {
        const rect = this.getBoundingClientRect();
        const drawerRect = drawerSearch.getBoundingClientRect();
        predictiveSearchEl.style.top = `${rect.bottom - drawerRect.top + 5}px`;
      }
    });
  }
});

// Ensure compatibility with existing search functionality
if (window.SearchForm) {
  customElements.define('search-form-drawer', class extends window.SearchForm {
    constructor() {
      super();
      this.input = this.querySelector('.search__input');
      this.resetButton = this.querySelector('.reset__button');
    }
  });
}